var map = {
	"./aml-sanctions/aml-sanctions.module": [
		"./src/app/application/aml-sanctions/aml-sanctions.module.ts"
	],
	"./application/application.module": [
		"./src/app/application/application.module.ts",
		"application-application-module"
	],
	"./back-office-wiki/back-office-wiki.module": [
		"./src/app/application/back-office-wiki/back-office-wiki.module.ts",
		"common",
		"back-office-wiki-back-office-wiki-module"
	],
	"./customer/customer.module": [
		"./src/app/application/customer/customer.module.ts",
		"common",
		"customer-customer-module"
	],
	"./release-notes/release-notes.module": [
		"./src/app/application/release-notes/release-notes.module.ts",
		"common",
		"release-notes-release-notes-module"
	],
	"./users/users.module": [
		"./src/app/application/users/users.module.ts",
		"users-users-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;